import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/auth";
import { Button, Card } from "@/components/primitives";
import logo from "@/assets/c4b-logo.png";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@coffee4business.com.au");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email, password);
      nav("/");
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Invalid email or password");
    } finally { setBusy(false); }
  };

  const inputStyle = {
    width: "100%", background: "var(--ui-bg)", border: "1px solid var(--ui-line)",
    borderRadius: 10, padding: "12px 14px", color: "var(--ui-text-hi)",
    fontFamily: "'Inter', sans-serif", fontSize: 14, marginTop: 6,
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", background: "var(--ui-bg)" }}>
      <Card style={{ width: 400, padding: 34 }}>
        <img src={logo} alt="coffee4business"
          style={{ width: 200, maxWidth: "100%", height: "auto", objectFit: "contain",
            display: "block", marginInline: "auto", marginBottom: 26 }} />
        <div className="num" style={{ fontSize: 22, fontWeight: 700, letterSpacing: "-0.6px", color: "var(--ui-text-hi)" }}>
          Bean Flow Monitor
        </div>
        <div className="prose-i" style={{ fontSize: 13, color: "var(--ui-text-lo)", marginTop: 4, marginBottom: 22 }}>
          Sign in to continue
        </div>
        <form onSubmit={submit}>
          <label className="prose-i" style={{ fontSize: 12, color: "var(--ui-text-mid)" }}>Email
            <input data-testid="login-email" style={inputStyle} value={email}
              onChange={(e) => setEmail(e.target.value)} type="email" />
          </label>
          <div style={{ height: 14 }} />
          <label className="prose-i" style={{ fontSize: 12, color: "var(--ui-text-mid)" }}>Password
            <input data-testid="login-password" style={inputStyle} value={password}
              onChange={(e) => setPassword(e.target.value)} type="password" />
          </label>
          {err && <div className="prose-i" style={{ color: "var(--sv-crit)", fontSize: 12.5, marginTop: 12 }}>{err}</div>}
          <Button data-testid="login-submit" type="submit" className="w-full"
            style={{ width: "100%", marginTop: 22 }} disabled={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </Button>
        </form>
        <div style={{ marginTop: 18, textAlign: "center" }}>
          <a href="/set-password" data-testid="activate-link" className="prose-i"
            style={{ fontSize: 12.5, color: "var(--ac-indigo-hi)", textDecoration: "none" }}>
            First time here? Activate your account →
          </a>
        </div>
      </Card>
    </div>
  );
}
